import { render, staticRenderFns } from "./TextAlign.vue?vue&type=template&id=418ce83f"
import script from "./TextAlign.vue?vue&type=script&lang=js"
export * from "./TextAlign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports